// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4959 ? "02df1d5b" : chunkId) + "." + {"84":"a231face93a5b89a","4959":"e6f60d2333212213","5842":"511d858616e08867","8254":"43ad412fc16c9a45"}[chunkId] + ".js";
};